import type {ConnectElementConfig} from '../ConnectElementList';
import {IS_HOSTED_DASHBOARD_ATTRIBUTE} from '../HtmlAttributes';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const TerminalHardwareOrdersConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "terminalHardwareOrders" */
      '../../../components/Terminal/HardwareOrders/HardwareOrders/TerminalHardwareOrders'
    ),
  teamOwner: 'terminal-logistics-eng',
  sentryTeam: 'terminal_hardware_orders',
  enabledKey: 'terminal_hardware_orders',
  enabledOverrideFlag: ComponentOverrideFlag.terminal_hardware_orders,
  htmlAttributes: {
    [IS_HOSTED_DASHBOARD_ATTRIBUTE]: {
      isInternal: true,
    },
  },
  customHtmlElementMethods: {
    setIsHostedDashboard: {
      type: 'AttributeSettingMethod',
      attribute: IS_HOSTED_DASHBOARD_ATTRIBUTE,
      isInternal: true,
      description:
        'Sets the is-hosted-dashboard attribute to control whether the terminal hardware orders component is rendered in a hosted dashboard (i.e. Express).',
    },
  },
  releaseState: 'preview',
  description: 'Shows a list of terminal hardware orders.',
  friendlyName: 'Terminal Hardware Orders',
  docSitePath:
    '/connect/supported-embedded-components/terminal-hardware-orders',
  syntheticTestInfo: {
    testUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/terminal-hardware-orders',
  },
};
